import { Route } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { authRoutes } from './routes/auth.routes';
import { errorRoutes } from './routes/error.routes';
import { withdrawRoutes } from './routes/withdraw.routes';
import { AuthGuard } from '../libs/guards/auth.guard';

export const appRoutes: Route[] = [
  {
    path: '',
    data: {
      layout: 'default',
    },
    component: LayoutComponent,
    children: [
      {
        path: 'splash',
        loadComponent: () => import('./pages/splash/splash.page'),
      },
      // 공통 돼지 상세 페이지
      {
        path: 'pig/:pigId',
        data: { mobileHeader: true },
        loadComponent: () =>
          import('./pages/my-page/holdings/pig-detail/pig-detail.page'),
      },
      { path: '', loadComponent: () => import('./pages/home/home.page') },
      // 상품 목록 페이지 (레이아웃 내부, 모바일 헤더 있음)
      {
        path: 'product',
        data: { mobileHeader: true },
        loadComponent: () => import('./pages/products/products.page'),
      },
      // 흑돼지 쇼핑 페이지
      {
        path: 'shop',
        data: { mobileHeader: true },
        loadComponent: () => import('./pages/shop/shop.page'),
      },
      // 흑돼지 쇼핑 상품 상세 페이지
      {
        path: 'shop/:id',
        data: { mobileHeader: true },
        loadComponent: () =>
          import('./pages/shop/shop-detail/shop-detail.page'),
      },
      // 흑돼지 쇼핑 주문서 페이지
      {
        path: 'shop/:id/order',
        canActivate: [AuthGuard],
        data: { mobileHeader: true },
        loadComponent: () => import('./pages/shop/shop-order/shop-order.page'),
      },
      // 상품 상세 페이지 (레이아웃 내부, 모바일 헤더 있음)
      {
        path: 'product/:id',
        data: { mobileHeader: true },
        loadComponent: () =>
          import('./pages/product-detail/product-detail.page'),
      },
      // 구매 신청 페이지 (레이아웃 내부, 로그인 필수)
      {
        path: 'product/:id/purchase',
        canActivate: [AuthGuard],
        data: { mobileHeader: true },
        loadComponent: () => import('./pages/purchase/purchase.page'),
      },
      // 구매 완료 페이지 (레이아웃 내부, 로그인 필수)
      {
        path: 'product/:id/purchase/complete',
        canActivate: [AuthGuard],
        data: { mobileHeader: true },
        loadComponent: () =>
          import('./pages/purchase/purchase-complete/purchase-complete.page'),
      },
      // 농가 상세 페이지 (레이아웃 내부, 모바일 헤더 있음)
      {
        path: 'farm/:id',
        data: { mobileHeader: true },
        loadComponent: () => import('./pages/farm-detail/farm-detail.page'),
      },
      // 투자 가이드 페이지 (레이아웃 내부, 모바일 헤더 있음)
      {
        path: 'investment-guide',
        data: { mobileHeader: true },
        loadComponent: () =>
          import('./pages/investment-guide/investment-guide.page'),
      },
      // Auth 페이지 (레이아웃 내부, 모바일 헤더 있음)
      ...authRoutes.map(route => ({
        ...route,
        data: { mobileHeader: true },
      })),
      // 고객지원 (공통 레이아웃 사용)
      {
        path: 'customer',
        data: { mobileHeader: true },
        loadComponent: () =>
          import('./pages/customer/customer-layout.component'),
        children: [
          {
            path: '',
            redirectTo: 'notice',
            pathMatch: 'full',
          },
          {
            path: 'notice',
            data: { mobileHeader: true },
            loadComponent: () => import('./pages/customer/notice/notice.page'),
          },
          {
            path: 'faq',
            data: { mobileHeader: true },
            loadComponent: () => import('./pages/customer/faq/faq.page'),
          },
        ],
      },
      // 고객지원 - 공지사항 상세 (레이아웃 외부)
      {
        path: 'customer/notice/:id',
        data: { mobileHeader: true },
        loadComponent: () =>
          import('./pages/customer/notice/notice-detail/notice-detail.page'),
      },
      // 문의하기 (마이페이지에서만 접근)
      {
        path: 'customer/inquiry',
        canActivate: [AuthGuard],
        data: { mobileHeader: true },
        loadComponent: () => import('./pages/customer/inquiry/inquiry.page'),
      },
      {
        path: 'customer/inquiry/form',
        canActivate: [AuthGuard],
        data: { mobileHeader: true },
        loadComponent: () =>
          import('./pages/customer/inquiry/inquiry-form/inquiry-form.page'),
      },
      {
        path: 'customer/inquiry/complete',
        canActivate: [AuthGuard],
        data: { mobileHeader: true },
        loadComponent: () =>
          import('./pages/customer/inquiry/inquiry-complete/inquiry-complete.page'),
      },
      {
        path: 'customer/inquiry/:id',
        canActivate: [AuthGuard],
        data: { mobileHeader: true },
        loadComponent: () =>
          import('./pages/customer/inquiry/inquiry-detail/inquiry-detail.page'),
      },

      // 마이페이지 (로그인 필수) - Nested Route 적용
      {
        path: 'my-page',
        canActivate: [AuthGuard],
        data: { mobileHeader: true },
        loadComponent: () =>
          import('./pages/my-page/layout/my-page-layout.component').then(
            m => m.MyPageLayoutComponent
          ),
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/my-page/my-page.page'),
          },
          // 보유 상품 목록
          {
            path: 'holdings',
            data: { mobileHeader: true },
            loadComponent: () =>
              import('./pages/my-page/holdings/holdings.page'),
          },
          // 보유 상품 상세
          {
            path: 'holdings/:orderId',
            data: { mobileHeader: true },
            loadComponent: () =>
              import('./pages/my-page/holdings/holding-detail/holding-detail.page'),
          },
          // 돼지 상세
          {
            path: 'holdings/:orderId/pig/:pigId',
            data: { mobileHeader: true },
            loadComponent: () =>
              import('./pages/my-page/holdings/pig-detail/pig-detail.page'),
          },
          // 구매 신청 내역
          {
            path: 'orders',
            data: { mobileHeader: true },
            loadComponent: () => import('./pages/my-page/orders/orders.page'),
          },
          // 입금 계좌 확인
          {
            path: 'orders/:id/deposit-info',
            data: { mobileHeader: true },
            loadComponent: () =>
              import('./pages/my-page/orders/deposit-info/deposit-info.page'),
          },
          // 내 정보 페이지
          {
            path: 'profile',
            data: { mobileHeader: true },
            loadComponent: () => import('./pages/my-page/profile/profile.page'),
          },
          // 이름 변경
          {
            path: 'profile/change-name',
            data: { mobileHeader: true },
            loadComponent: () =>
              import('./pages/my-page/profile/change-name/change-name.page'),
          },
          // 휴대폰 번호 변경
          {
            path: 'profile/change-phone',
            data: { mobileHeader: true },
            loadComponent: () =>
              import('./pages/my-page/profile/change-phone/change-phone.page'),
          },
          // PIN 변경
          {
            path: 'profile/change-pin',
            data: { mobileHeader: true },
            loadComponent: () =>
              import('./pages/my-page/profile/change-pin/change-pin.page'),
          },
          // 환불계좌 등록/변경
          {
            path: 'profile/refund-account',
            data: { mobileHeader: true },
            loadComponent: () =>
              import('./pages/my-page/profile/refund-account/refund-account.page'),
          },
          // 정산 내역
          {
            path: 'settlements',
            data: { mobileHeader: true },
            loadComponent: () =>
              import('./pages/my-page/settlements/settlements.page'),
          },
          // 찜한 상품 목록
          {
            path: 'wishlist',
            data: { mobileHeader: true },
            loadComponent: () =>
              import('./pages/my-page/wishlist/wishlist.page'),
          },
          // 알림 목록
          {
            path: 'notification-list',
            data: { mobileHeader: true },
            loadComponent: () =>
              import('./pages/my-page/notification-list/notification-list.page'),
          },
          // 알림 설정
          {
            path: 'notifications',
            data: { mobileHeader: true },
            loadComponent: () =>
              import('./pages/settings/notification-settings/notification-settings.page'),
          },
          // 회원탈퇴
          {
            path: 'withdraw/reason',
            data: { mobileHeader: true },
            loadComponent: () => import('./pages/withdraw/reason/reason.page'),
          },
          {
            path: 'withdraw/verify',
            data: { mobileHeader: true },
            loadComponent: () => import('./pages/withdraw/verify/verify.page'),
          },
          {
            path: 'withdraw/confirm',
            data: { mobileHeader: true },
            loadComponent: () =>
              import('./pages/withdraw/confirm/confirm.page'),
          },
          // 문의 내역
          {
            path: 'inquiry',
            data: { mobileHeader: true },
            loadComponent: () =>
              import('./pages/customer/inquiry/inquiry.page'),
          },
          {
            path: 'inquiry/form',
            data: { mobileHeader: true },
            loadComponent: () =>
              import('./pages/customer/inquiry/inquiry-form/inquiry-form.page'),
          },
          {
            path: 'inquiry/complete',
            data: { mobileHeader: true },
            loadComponent: () =>
              import('./pages/customer/inquiry/inquiry-complete/inquiry-complete.page'),
          },
          {
            path: 'inquiry/:id',
            data: { mobileHeader: true },
            loadComponent: () =>
              import('./pages/customer/inquiry/inquiry-detail/inquiry-detail.page'),
          },
        ],
      },

      // 설정 페이지 (로그인 필수)
      {
        path: 'settings',
        canActivate: [AuthGuard],
        data: { mobileHeader: true },
        loadComponent: () => import('./pages/settings/settings.page'),
      },
      // 알림 설정 페이지 (로그인 필수)
      {
        path: 'settings/notifications',
        canActivate: [AuthGuard],
        data: { mobileHeader: true },
        loadComponent: () =>
          import('./pages/settings/notification-settings/notification-settings.page'),
      },

      // 사업자 정보 페이지
      {
        path: 'business-info',
        data: { mobileHeader: true },
        loadComponent: () => import('./pages/business-info/business-info.page'),
      },
      ...errorRoutes,
    ],
  },

  // 약관 페이지
  {
    path: 'terms/:type',
    loadComponent: () => import('./pages/terms/terms.page'),
  },
  // 회원탈퇴 (모바일용, 로그인 필수)
  ...withdrawRoutes.map(route => ({
    ...route,
    canActivate: [AuthGuard],
  })),
  // 마케팅 약관 페이지 (로그인 필수, Layout 없이)
  {
    path: 'settings/notifications/marketing',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/settings/notification-settings/marketing-terms/marketing-terms.page'),
  },
];
